import i18n from "@/i18n";
import { createPinia } from "pinia";
import { createApp, markRaw } from "vue";
import App from "./App.vue";
import router from "./router";
//@ts-ignore
import mitt from "mitt";
//@ts-ignore
import KnobControl from "vue-knob-control";
const pinia = createPinia();
const emitter = mitt();
//@ts-ignore
import A11yDialog from "vue-a11y-dialog";

// import "@/assets/css/app.css";
// import "@/assets/css/app-dark.css";
// import "@/assets/css/bootstrap-dark.css";
// import "@/assets/css/icons.css";
// import "bootstrap/dist/css/bootstrap.css";
import "@/assets/css/bootstrap.css";
import ApiHelper from "@/helpsers/api.helper";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import VCalendar from "v-calendar";
import "v-calendar/dist/style.css";
import Vue3TouchEvents from "vue3-touch-events";
import "./css/fonts.scss";
import "./css/styles.scss";
// import { initSentry } from "@/js/sentry";
// initSentry();
import "bootstrap/dist/js/bootstrap.js";
import dayjs from "dayjs";
import storeCache from "./js/storeCache";
require("dayjs/locale/pl");
require("dayjs/locale/de");
require("dayjs/locale/en");
pinia.use(({ store }) => {
  store.$router = markRaw(router);
});

const app = createApp(App).use(pinia).use(i18n).use(Vue3TouchEvents).use(A11yDialog).use(KnobControl).use(VCalendar).provide("emitter", emitter);
dayjs.locale(storeCache.get("lang") || "pl");
if (window.location.href.includes("localhost")) {
  console.log("Application running locally");
} else {
  console.log("Application running on server");
  Sentry.init({
    //@ts-ignore
    app,
    dsn: ApiHelper.returnSentryDns(),
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: ["http://localhost:8082", "app2.logiplanner.eu", /^\//],
      }),
    ],
    ignoreErrors: [
      "HTTP/1.1 404 Not Found - Brak danych",
      "Cannot read properties of undefined (reading 'showAlert')",
      "Unexpected token '<'",
      'Could not load "places_impl"',
    ],
    tracesSampleRate: 1.0,
  });
}
const langToRegion: Record<string, string> = { pl: "PL", en: "GB", de: "DE" };
const lang = storeCache.get("lang") || "pl";
app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBZHENgIENpf1MlP0H3Mli9ksmeCUbZVBw",
    libraries: "places",
    language: lang,
    region: langToRegion[lang] || "PL",
  },
  autobindAllEvents: true,
});
app.component("Datepicker", Datepicker);
app.use(router);
app.mount("#app");
